import { connect } from 'react-redux';
import { toast } from '../../redux/actions/toasts-actions';
import VoucherVerifyPage from './voucher-verify-page';

const mapDispatchToProps = { toast };

export default connect(null, mapDispatchToProps)(VoucherVerifyPage);
